export function createRng(seed) {
  let s = (seed >>> 0) || 1;
  function next() {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  next.uniform = (min, max) => min + next() * (max - min);
  next.integer = (min, maxExclusive) =>
    Math.floor(min + next() * (maxExclusive - min));
  next.choice = (arr) => arr[Math.floor(next() * arr.length)];
  next.bool = (p = 0.5) => next() < p;
  return next;
}

export function deriveSeed(parentSeed, label) {
  let h = parentSeed >>> 0;
  for (let i = 0; i < label.length; i++) {
    h = Math.imul(h ^ label.charCodeAt(i), 0x01000193) >>> 0;
  }
  return h >>> 0;
}
